import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FileDownloaded } from '../../../model';
import walletRepository from '../../../repositories/wallet/wallet-repository';
import { getCurrentState } from '../../../store/features/wallet/my-wallet/my-wallet-selectors';
import { useAppSelector } from '../../redux';

export interface MyWalletSchedaProdottoLogic {
  pdf?: FileDownloaded;
  url?: string;
  pdfLoading: boolean;
  error: boolean;
}

export const useMyWalletSchedaProdottoLogic = (): MyWalletSchedaProdottoLogic => {

  const { productDetails, productDetailsSelectedSection }: any =
    useSelector(getCurrentState);
  const token: string = useAppSelector((state) => state.data?.user?.token);

  const [content, setContent] = useState<FileDownloaded>();
  const [pdfLoading, setPdfLoading] = useState(false);
  const [schedaProdottoError, setSchedaProdottoError] = useState<boolean>(false);

  const retrieveData = useCallback(
    async (documentIsin: string) => {
      try {
        return await walletRepository.downloadSchedaProdotto(
          token,
          documentIsin
        );
      } catch (error) {
        return null;
      }
    },
    [token]
  );

  const downloadContent = useCallback(
    async (documentIsin: string) => {
      setPdfLoading(true);
      const blob = (await retrieveData(documentIsin)) as Blob;

      if (blob) {
        setContent({
          name: `${documentIsin}.pdf`,
          blob,
          mediaType: 'pdf',
          type: 'productDetails',
        });
      } else {
        setSchedaProdottoError(true);
        setContent(undefined);
      }

      setPdfLoading(false);
    },
    [retrieveData]
  );

  useEffect(() => {
    setContent(undefined);
    setSchedaProdottoError(false);
    setPdfLoading(false);
  }, [productDetails?.ISIN]);

  useEffect(() => {
    if (productDetails?.ISIN && productDetailsSelectedSection === 'PDFVIEW') {
      downloadContent(productDetails?.ISIN);
    }
  }, [downloadContent, productDetails?.ISIN, productDetailsSelectedSection]);


  return {
    pdf: content,
    pdfLoading,
    error: schedaProdottoError
  };
};
